import React from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import {injectIntl} from 'react-intl';
import {
    FormGroup, FormControl, ControlLabel,
    Form, Row, Col, Checkbox, Button, ButtonToolbar, Alert
} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';

// import AttachmentFormGroup from './AttachmentFormGroup'
// import Attachments from './Attachments'
import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";
import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import {KEY_PARTNER_TYPES} from "./constants";
import AITextEditor from '../AITextEditor';

@observer
class KeyPartnersForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            name: "",
            description: "",
            attach_url: undefined,
            types: [],
            utility: "",
            address: "",
            contactInformation: "",
            isEdition: false,
        };

        this.canDeleteCard = props.blockStore.rootStore.authorizationStore.canDeleteCard(props.blockStore.editingCard);

        this.renderSaveOrUpdateButton = this.renderSaveOrUpdateButton.bind(this);
        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleUtilityChange = this.handleUtilityChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleContactInformationChange = this.handleContactInformationChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        // this.handleAttachmentChange = this.handleAttachmentChange.bind(this);

    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {

        const {blockStore, intl} = this.props;

        let cancelBtn;

        if (this.props.hideCancelBtn == null) {
            cancelBtn = <Button bsStyle="default" onClick={this.handleCancel}>
                {intl.formatMessage({id: "cancel"})}
            </Button>;
        } else {
            cancelBtn = <div></div>;
        }


        const labelValue = this.state.label.trim() ?
            intl.formatMessage({
                id: this.state.label,
                defaultMessage: " "
            }) : "";

        return (
            <div>

                {this.state.isEdition && (

                    <FormGroup
                        controlId="LabelKPId"
                        validationState={this.validateLabel()}>
                        <Row>
                            <Col xs={12} sm={2}>
                                <ControlLabel> {intl.formatMessage({id: "station"})} </ControlLabel>
                            </Col>
                            <Col xs={12} sm={10}>
                                <FormControl
                                    type="text"
                                    value={labelValue}
                                    placeholder=""
                                    onChange={this.handleLabelChange}
                                    disabled={true}
                                />
                            </Col>
                        </Row>

                    </FormGroup>
                )}


                <FormGroup
                    controlId="NameKPId"
                    validationState={this.validateName()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "name"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder=""
                                onChange={this.handleNameChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="DescriptionKPId" validationState={this.validateDescription()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <AITextEditor
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value})}
                                context="El texto con el que estás trabajando es sobre la descripción de socios clave en un modelo de negocio Canvas. Los socios clave son la red de proveedores y aliados que hacen que el modelo de negocio funcione. Incluye alianzas estratégicas, joint ventures, proveedores confiables, y relaciones comprador-proveedor."
                                rows={4}
                                placeholder=""
                            />
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderTypesSelect()}


                <FormGroup
                    controlId="UtilityKPId"
                    validationState={this.validateUtility()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "utility"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.utility}
                                placeholder=""
                                onChange={this.handleUtilityChange}
                            />
                        </Col>
                    </Row>

                </FormGroup>

                <FormGroup
                    controlId="AddressKPId"
                    validationState={this.validateAddress()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "address"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.address}
                                placeholder=""
                                onChange={this.handleAddressChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="ContactInformationKPId"
                           validationState={this.validateContactInformation()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "contact-information"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl componentClass="textarea"
                                         value={this.state.contactInformation}
                                         placeholder=""
                                         onChange={this.handleContactInformationChange}/>
                        </Col>
                    </Row>
                </FormGroup>


                {/*<AttachmentFormGroup isEdition={this.state.isEdition}*/}
                {/*card={blockStore.editingCard}*/}
                {/*onAttachmentChange={this.handleAttachmentChange}*/}
                {/*/>*/}

                {/*<Attachments card={blockStore.editingCard}/>*/}
                <AttachmentsForm attachable={blockStore.editingCard}/>

                <br/>

                <ButtonToolbar className="pull-right">
                    {this.renderSaveOrUpdateButton()}

                    {this.state.isEdition && this.canDeleteCard && (
                        <ButtonWithConfirmation dropdownClassname="bmc-card-delete-button"
                                                confirmationMessage={intl.formatMessage({id: "delete_confirmation_msg"})}
                                                option1Label={intl.formatMessage({id: "delete_confirmation_no"})}
                                                option2Label={intl.formatMessage({id: "delete_confirmation_yes"})}
                                                onOption2Select={this.handleDelete}
                                                dropup>
                            {intl.formatMessage({id: "delete"})}
                        </ButtonWithConfirmation>
                    )}

                    {cancelBtn}
                </ButtonToolbar>

                <div className="clearfix"/>

            </div>
        );
    }

    renderSaveOrUpdateButton() {

        if (this.state.isEdition) {
            return (
                <Button bsStyle="primary" onClick={this.handleUpdate}>
                    {this.props.intl.formatMessage({id: "save"})}
                </Button>
            )
        } else {
            const buttonMessage = this.props.blockStore.rootStore.stepByStepMode ? "save" : "add";

            return (
                <Button bsStyle="primary" onClick={this.handleSubmit}
                        disabled={!this.state.name && !this.state.description}>
                    {this.props.intl.formatMessage({id: buttonMessage})}
                </Button>
            )
        }


    }

    renderTypesSelect = () => {

        //const {intl} = this.props;
        return (

            <FormGroup
                controlId="TypeKPId"
                validationState={this.validateTypes()}
            >
                <Row>
                    <Col xs={12} sm={2}>
                        <ControlLabel> {this.props.intl.formatMessage({id: "types"})} </ControlLabel>
                    </Col>
                    <Col xs={12} sm={10}>
                        <Select
                            multi
                            onChange={this.handleTypesChange}
                            value={this.state.types}
                            placeholder=""
                            options={this.renderTypeSelectOptions()}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    };

    renderTypeSelectOptions = () => {

        return Object.entries(KEY_PARTNER_TYPES).map(i => ({
            value: i[1],
            label: this.props.intl.formatMessage({id: i[1]})
        }));

    };


    handleLabelChange(e) {
        //this.setState({label: e.target.value});
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleUtilityChange(e) {
        this.setState({utility: e.target.value});
    }

    handleTypesChange = (options) => {
        this.setState({types: options});
    };

    handleAddressChange(e) {
        this.setState({address: e.target.value});
    }

    handleContactInformationChange(e) {
        this.setState({contactInformation: e.target.value});
    }

    handleDescriptionChange(e) {
        this.setState({description: e.target.value});
    }


    validateLabel() {

    }

    validateName() {

    }

    validateTypes() {

    }

    validateUtility() {

    }

    validateAddress() {

    }

    validateContactInformation() {

    }

    validateDescription() {

    }

    @action
    handleSubmit() {
        const card = this.generateCardFromState();
        this.props.blockStore.addCard(card);
        this.props.blockStore.showBlockModal(false);

        this.resetForm();
    }


    @action
    handleCancel() {
        const {blockStore} = this.props;

        blockStore.hideBlockModal(true);

        this.resetForm();
    }

    @action
    handleUpdate() {
        this.generateCardFromState();

        const {blockStore} = this.props;

        if (blockStore.editingCard.persisted) {
            blockStore.editingCard.update();
            blockStore.showBlockModal(false);
        }
    }


    @action
    handleDelete() {
        this.props.blockStore.editingCard.destroy();
        this.props.blockStore.hideBlockModal(true);

    }


    generateCardFromState() {
        const {editingCard} = this.props.blockStore;

        editingCard.label = this.state.label;
        editingCard.name = this.state.name;
        editingCard.description = this.state.description;
        editingCard.types = this.state.types.map(t => t.value);
        editingCard.utility = this.state.utility;
        editingCard.address = this.state.address;
        editingCard.contactInformation = this.state.contactInformation;

        return editingCard;
    }

    resetForm() {
        this.setState({
            label: "",
            name: "",
            description: "",
            attach_url: undefined,
            utility: "",
            address: "",
            contactInformation: "",

            isEdition: false,
        });
    }


    componentDidMount() {
        this.initFields(this.props.blockStore.editingCard);
    }

    initFields(card) {

        //const card = this.props.blockStore.editingCard;
        this.setState({
            label: card.label,
            name: card.name,
            types: card.types.map(t => {
                return {value: t, label: this.props.intl.formatMessage({id: t})}
            }),
            utility: card.utility,
            address: card.address,
            contactInformation: card.contactInformation,

            isEdition: card.persisted,
            description: card.description,
        });
    }
}

export default injectIntl(KeyPartnersForm);